import { StoreContext } from '@roc/feature-app-core';
import { useContext } from 'react';
import { LenderBankInformationStore } from '../stores/lenderBankInformationStore';

export const useLenderBankInformationStore = () =>
  useContext<{
    lenderBankInformationStore: LenderBankInformationStore;
  }>(StoreContext);